import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { CheckCircle, XCircle, Loader } from 'lucide-react';
import { api } from '../../utils/api';
import Header from '../shared/Header';
import Footer from '../shared/Footer';

const VerifyEmailPage = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const token = searchParams.get('token');

  useEffect(() => {
    if (token) {
      api.verifyEmail(token)
        .then(() => {
          setStatus('success');
          setMessage('Email verified successfully! Your account is pending admin approval. We will notify you once approved.');
        })
        .catch((error) => {
          setStatus('error');
          setMessage(error.response?.data?.detail || 'Verification failed. The link may be invalid or expired.');
        });
    } else {
      setStatus('error');
      setMessage('No verification token provided.');
    }
  }, [token]);

  return (
    <div className="min-h-screen bg-[#FCFBF9] flex flex-col">
      <Header />
      
      <div className="flex-1 flex items-center justify-center py-12 px-6">
        <div className="w-full max-w-md">
          <div className="bg-white rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.08)] border border-[#E6DCD3] p-8 text-center" data-testid="verify-email-container">
            {status === 'loading' && (
              <>
                <Loader className="h-16 w-16 text-[#3E2723] mx-auto mb-4 animate-spin" />
                <h1 className="font-serif text-2xl text-[#3E2723] mb-2">Verifying Email...</h1>
                <p className="text-[#786E66]">Please wait while we verify your email address.</p>
              </>
            )}
            
            {status === 'success' && (
              <>
                <CheckCircle className="h-16 w-16 text-green-600 mx-auto mb-4" />
                <h1 className="font-serif text-2xl text-[#3E2723] mb-4">Email Verified!</h1>
                <div className="bg-[#F3EBE1] rounded-lg p-6 mb-6">
                  <p className="text-[#1A1A1A] font-medium mb-2">What happens next?</p>
                  <p className="text-[#786E66] text-sm">Your account is pending admin approval. We'll send you an email notification once your account has been reviewed and approved. This usually takes 24-48 hours.</p>
                </div>
                <button
                  onClick={() => navigate('/login')}
                  className="bg-[#3E2723] text-white hover:bg-[#2A1A17] rounded-full px-8 py-3 transition-all hover:-translate-y-0.5 w-full"
                  data-testid="continue-to-login-button"
                >
                  Continue to Login
                </button>
              </>
            )}
            
            {status === 'error' && (
              <>
                <XCircle className="h-16 w-16 text-red-600 mx-auto mb-4" />
                <h1 className="font-serif text-2xl text-[#3E2723] mb-2">Verification Failed</h1>
                <p className="text-[#786E66] mb-6">{message}</p>
                <button
                  onClick={() => navigate('/login')}
                  className="bg-[#3E2723] text-white hover:bg-[#2A1A17] rounded-full px-8 py-3 transition-all hover:-translate-y-0.5"
                >
                  Go to Login
                </button>
              </>
            )}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default VerifyEmailPage;
